import { Link } from "react-router-dom";
import type { Recipe } from "../types";

const IMAGES_BASE =
  import.meta.env.VITE_IMAGES_BASE_URL ?? "http://localhost:3001/images";

interface RecipeTileProps {
  recipe: Recipe;
}

export default function RecipeTile({ recipe }: RecipeTileProps) {
  const imageUrl = `${IMAGES_BASE}/${recipe.thumbnailKey}`;

  return (
    <Link
      to={`/recipe/${recipe.slug}`}
      className="group block rounded-xl overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow duration-200"
    >
      <div className="relative aspect-square overflow-hidden bg-stone-100">
        <img
          src={imageUrl}
          alt={recipe.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-end p-3">
          <p className="text-white text-xs line-clamp-3 leading-snug">
            {recipe.description}
          </p>
        </div>
      </div>

      <div className="p-3">
        <h3 className="text-sm font-semibold text-stone-800 leading-tight line-clamp-2">
          {recipe.title}
        </h3>
        <p className="text-xs text-stone-500 mt-1 capitalize">{recipe.course}</p>
      </div>
    </Link>
  );
}
